export enum SellerMethods {
  GET_SELLER = 'get_seller' as any
}
